import './date_filter_view.js.coffee'
import './generic_user_filter_view.js.coffee'
import '../../../models/account_settings/user_profile_attributes/user_profile_attribute.js.coffee'

Namespace('Profiling.Dashboard.Filters')

class Profiling.Dashboard.Filters.FiltersView extends Backbone.View
  template: JST['backbone/templates/profiling/filters']

  events:
    'click .removeAll': 'onRemoveAllFilters'
    'click a.toggle': 'toggle'

  onRemoveAllFilters: =>
    @searchQuery.removeAllFilters()
    @searchQuery.triggerFilterChanged()

  initialize: ({session, profileTags, facets}) ->
    @searchQuery = new Profiling.Models.SearchQuery(session: notNull(session))
    @profileTags = notNull(profileTags)
    @facets = facets
    @listenTo @searchQuery, 'filterChanged', (session) =>
      @trigger('filterChanged', session)

  destroy: ->
    @remove()
    return false

  render: ->
    @$el.html(@template())
    filters_container = @$el.find('#filters-container')
    @renderDefaultFilters(filters_container)
    @renderCustomFilters(filters_container)
    @

  renderDefaultFilters: (filters_container) =>
    attributes = new AccountSettings.UserProfileAttributeCollection([
      {
        attribute_type_name: 'Date'
        code: 'created'
        name: I18n.t('profiling.dashboard.filters.names.created')
        tags: []
      }
      {
        attribute_type_name: 'Date'
        code: 'updated'
        name: I18n.t('profiling.dashboard.filters.names.updated')
        tags: []
      }
      {
        attribute_type_name: 'Text'
        code: 'names_usernames'
        name: I18n.t('profiling.dashboard.filters.names.names_usernames')
        tags: []
      }
      {
        attribute_type_name: 'FixedString'
        code: 'tags'
        name: I18n.t('profiling.dashboard.filters.names.tags')
        tags: @profileTags.map((tag) -> name: tag.get('description'))
      }
    ])
    @$el.find('#default_filters').html(
      new Profiling.Dashboard.Filters.FilterGroupView(
        searchQuery: @searchQuery
        customAttributes: attributes
        facets: @facets
        filtersContainer: filters_container
      ).render(
        $appliedEl: @$el.find('#applied_default_filters')
      ).el
    )

  renderCustomFilters: (filters_container) =>
    return @createAndRenderCustomFilters(filters_container) unless @customFiltersView
    @$el.find('#custom_filters').html(
      @customFiltersView.render(
        $appliedEl: @$el.find('#applied_custom_filters')
      ).el
    )

  createAndRenderCustomFilters: (filters_container) =>
    new AccountSettings.UserProfileAttributeCollection().fetch(success: (attributes) =>
      attributes.forEach (attribute) ->
        attribute.set('code', "ca_#{attribute.get('code')}")
      @customFiltersView = new Profiling.Dashboard.Filters.FilterGroupView
        searchQuery: @searchQuery
        customAttributes: attributes
        facets: @facets
        filtersContainer: filters_container
      @renderCustomFilters()
    )

  toggle: (e) =>
    @constructor.toggleFilter($(e.currentTarget).parent())

  @toggleFilter: (filter) ->
    icon = filter.find('i:not(".fa")')
    filter.toggleClass 'collapsed expanded'
    icon.toggleClass 'icon-chevron-down icon-chevron-right'
    filter.parent().find('.one-click-open').click()
